// Stripe URLs
export const STRIPE_GLOBAL_AVAILABILITY_URL = 'https://stripe.com/global';
export const STRIPE_SUPPORT_URL = 'https://support.stripe.com/';
export const STRIPE_PRICING_URL = 'https://stripe.com/pricing';
export const HUBSPOT_PAYMENTS_CURRENCIES_URL = 'https://knowledge.hubspot.com/payments/use-multiple-currencies-with-stripe#:~:text=Available%20Currencies,-Through%20Stripe';
export const HUBSPOT_PAYMENTS_TERMS_URL = 'https://legal.hubspot.com/payments-terms-of-use';
export const HUBSPOT_PAYMENTS_PROMO_URL = 'https://legal.hubspot.com/commercehub-promo';